import serialize from "./serialize";

var getDestination = function getDestination(element) {
  if (element.nodeName === 'A') {
    return element.getAttribute('href');
  } else if (element.nodeName === 'FORM') {
    var action = element.getAttribute('action');
    var method = element.getAttribute('method');

    if (!method || method.toLowerCase() === 'get') {
      var body = serialize(element);
      return "".concat(action, "?").concat(body);
    }

    return action;
  }
};

export default getDestination;